// the Uniswap Default token list lives here
export const DEFAULT_TOKEN_LIST_URL = 'https://www.teaswap.art/default-token-list/mainnet.json'
//export const DEFAULT_TOKEN_LIST_URL = 'http://localhost:3000/default-token-list/mainnet.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL]
